import type { Dispatch, FC, SetStateAction } from "react";
import { useIntl } from "react-intl";
import { Select } from "@mantine/core";

export interface APIKeySelectorProps {
  apiKeys: {
    id: number;
    name: string;
  }[];
  apiKeyId: number | undefined;
  setApiKeyId: Dispatch<SetStateAction<number | undefined>>;
}

export const APIKeySelector: FC<APIKeySelectorProps> = ({ apiKeys, apiKeyId, setApiKeyId }) => {
  const intl = useIntl();

  return (
    <Select
      clearable
      placeholder={intl.formatMessage({
        defaultMessage: "Filter by API key",
        id: "placeholder.chooseAnApiKey",
      })}
      data={apiKeys.map(apiKey => ({
        value: apiKey.id.toString(),
        label: apiKey.name,
      }))}
      value={apiKeyId?.toString()}
      onChange={(value) => {
        setApiKeyId(value ? Number(value) : undefined);
      }}
    />
  );
};
